import * as React from 'react';

export const TickIcon = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='15.567' height='11.699' viewBox='0 0 15.567 11.699'>
            <path d='M50.728-5.146l-9.8,9.934a.844.844,0,0,1-1.222,0L35.672.655a.9.9,0,0,1,0-1.242.844.844,0,0,1,1.222,0l3.434,3.512,9.2-9.313a.844.844,0,0,1,1.222,0A.884.884,0,0,1,50.728-5.146Z' transform='translate(-35.425 6.65)' fill='#219520' fillRule='evenodd'/>
        </svg>
    );
};
